







































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import {
  OpenRepairOrderViewModel,
  RepairOrderResponseViewModel,
  AddAttachmentModel,
  AttachmentInfoViewModel,
  RoEmailViewModel,
  GetEmailDetailModel,
  MakeCallModel,
  VoiceCallModel,
} from '@/models/fixedops/repairorder';
import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
import { VFields } from '@/models/v-fields';
import { AttachmentType } from '@/models/fixedops/attachment';
import { Base } from '../common/base';
import {
  attachmentTypeService,
  repairOrderService,
  customerService,
  voiceCallService,
} from '@/shared';

declare const generatePdf;

@Component({
  computed: {
    paginations: {
      get() {
        return this.$props.pagination;
      },
      set(val) {
        this.$emit('paging', val);
      },
    },
    buttonType: {
      get() {
        if (this.email.customer && this.email.self) {
          return 'both';
        } else {
          if (this.email.customer) {
            return 'customer';
          } else {
            return 'self';
          }
        }
      },
    },
  },
  components: {
    Grid: () => import('../common/app.grid.vue'),
    AttachmentForm: () => import('./attachment.add.vue'),
    CustomerInformation: () => import('./customer.information.vue'),
    VoiceConversation: () => import('./voice.conversation.vue'),
    EmailSend: () => import('./email.send.vue'),
  },
  props: [
    'pagedOrders',
    'pagination',
    'loading',
    'openOrder',
    'methodName',
    'progress',
  ],
})
export default class OpenOrderListComponent extends Base {
  public paginations: PaginationModel;
  public roNumber: string = '';
  public methodName: string = '';
  public childProgress: boolean = false;

  public flags: any = {
    showForm: false,
    showEmailPopup: false,
    showCustomerInfo: false,
    showCallPopup: false,
  };
  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.status') as string,
      value: `roStatus`,
      fieldType: 'template',
      template: (item) => {
        if (!item.paymentDetail) {
          return `<span> ${item.roStatus || 'N/A'} </span>`;
        }
        if (item.paymentDetail && item.completePayment) {
          return `<span>
                            <v-icon color="green">fas fa-dollar-sign</v-icon>
                            <span style="color: #388E3C;"> ${item.roStatus ||
                              'N/A'} </span>
                            </span>`;
        }

        if (item.paymentDetail && !item.completePayment) {
          return `<span>
                            <v-icon color="orange">fas fa-dollar-sign</v-icon>
                            <span style="color: #F57C00;"> ${item.roStatus ||
                              'N/A'} </span>
                            </span>`;
        }
      },
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.ro') as string,
      value: 'repairOrderNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.customer') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.lastVin') as string,
      value: 'vin',
      filters: [
        (val, item) => {
          return item.vin.length > 10
            ? item.vin.substring(item.vin.length - 8, item.vin.length)
            : item.vin || 'N/A';
        },
      ],
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.svcWriter') as string,
      value: `serviceWriterName`,
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.tag') as string,
      value: `tagNumber`,
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t('openRo.openRepairOrderGrid.actions') as string,
      sortable: false,
    },
  ];
  public actions: any[] = [];
  public calling;
  public buttonType;
  public email: any = {
    self: false,
    customer: false,
    from: '',
    froms: [],
  };

  public customerModel: OpenRepairOrderViewModel = {};
  public emailSendModel: OpenRepairOrderViewModel = {};
  public callModel: OpenRepairOrderViewModel = {};

  public openOrder: RepairOrderResponseViewModel;
  public addAttachmentTypeModel: AddAttachmentModel = {};
  public attachmentDetails: AttachmentInfoViewModel[] = [];
  public customerInfo: OpenRepairOrderViewModel = {};
  public emailModel: RoEmailViewModel = { storeId: 0, storeName: '' };
  public customerPhoneNumber(): string {
    let pNumber = '';
    switch (this.customerInfo.callTo) {
      case 'home': {
        pNumber = this.customerInfo.customerPhoneNumber;
        break;
      }
      case 'cellphone': {
        pNumber = this.customerInfo.cellPhone;
        break;
      }
      case 'businessPhone': {
        pNumber = this.customerInfo.businessPhone;
        break;
      }
      case 'other': {
        pNumber = this.customerInfo.otherNumber;
        break;
      }
      default: {
        pNumber = this.customerInfo.customerPhoneNumber;
      }
    }
    return pNumber;
  }

  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit('updateChildToolBar', buttons);
  }
  public updateChildToolBar(buttons): void {
    if (this.flags.showForm) {
      this.updateToolBar(buttons);
    }
  }
  public resetMethodName(methodName): void {
    this.$emit('resetMethodName', methodName);
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateChildToolBar', buttons);
  }
  public callMethod(methodName): void {
  }
  public mounted(): void {
    this.setActions();

    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.methodName = newVal;
        this.callMethod(newVal);
      }
    });
    this.$watch('flags.showForm', (newVal, oldVal) => {
      if (newVal === false) {
        this.updateToolBar(null);
      }
    });
    this.$watch('childProgress', (newVal, oldVal) => {
      this.$emit('update:childProgress', newVal);
    });
  }

  public viewAttachment(model: OpenRepairOrderViewModel): void {
    this.roNumber = model.repairOrderNumber;
    this.flags.showForm = true;
    this.$emit('updateFlag', 'showForm', true);
  }
  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fa fa-eye',
        text: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.view'
        ) as string,
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.view'
        ) as string,
        visible: (model: OpenRepairOrderViewModel) => {
          return true;
        },
        action: (model: OpenRepairOrderViewModel, storeid: string) => {
          return {
            name: 'app.repairorders.detail',
            params: {
              roNumber: model.repairOrderNumber,
            },
            query: {
              sType: 'o',
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fa fa-envelope',
        text: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.sendEmail'
        ) as string,
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.sendEmail'
        ) as string,
        visible: (model: OpenRepairOrderViewModel) => {
          return this.openOrder.isAdvisorRole;
        },
        action: (model: OpenRepairOrderViewModel, storeid: string) => {
          this.emailSendModel = model;
          this.flags.showEmailPopup = true;
        },
      },
      {
        type: 'button',
        icon: 'fa fa-user',
        text: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.customerInformation'
        ) as string,
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.customerInformation'
        ) as string,
        visible: (model: OpenRepairOrderViewModel) => {
          return true;
        },
        action: (model: OpenRepairOrderViewModel, storeid: string) => {
          this.customerModel = model;
          this.flags.showCustomerInfo = true;
        },
      },
      {
        type: 'button',
        icon: 'fa fa-paperclip',
        text: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.viewAttachments'
        ) as string,
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.viewAttachments'
        ) as string,
        visible: (model: OpenRepairOrderViewModel) => {
          return true;
        },
        action: (model: OpenRepairOrderViewModel, storeid: string) => {
          this.viewAttachment(model);
        },
      },
      {
        type: 'link',
        icon: 'fas fa-comment',
        text: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.sendMessage'
        ) as string,
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.sendMessage'
        ) as string,
        visible: (model: OpenRepairOrderViewModel) => {
          return (
            this.openOrder.isMessagingEnabled &&
            model.customerKey !== '0' &&
            model.customerKey &&
            this.openOrder.isAdvisorRole &&
            this.isFeatureToAccess('MESSAGING')
          );
        },
        action: (model: OpenRepairOrderViewModel) => {
          return {
            name: 'advisor.conversation.add',
            params: {
              type: MetadataType[MetadataType.RO],
            },
            query: {
              recordKey: model.repairOrderNumber,
              customerKey: model.customerKey,
              vin: model.vin,
              sType: 'o',
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fa fa-phone',
        text: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.callCustomer'
        ) as string,
        title: this.$parent.$t(
          'openRo.openRepairOrderGrid.gridActions.callCustomer'
        ) as string,
        visible: (model: OpenRepairOrderViewModel) => {
          return (
            this.openOrder.isMessagingEnabled &&
            model.customerKey !== '0' &&
            model.customerKey &&
            this.openOrder.isAdvisorRole &&
            this.isFeatureToAccess('MESSAGING')
          );
        },
        action: (model: OpenRepairOrderViewModel, storeid: string) => {
          this.callModel = model;
          this.flags.showCallPopup = true;
        },
      },
    ];
  }

  public newMessage(model): void {
    this.$router.push({
      name: 'advisor.conversation.add',
      query: {
        repairOrderNumber: model.repairOrderNumber,
        customerPhoneNumber: model.customerPhoneNumber,
        customerName: model.customerName,
        customerKey: model.customerKey,
      },
    });
  }

  public updatePaging(paging: any) {
    this.paginations = paging;
  }
  public updateFlag(flag, value): void {
    this.flags[flag] = value;
    this.$emit('updateFlag', flag, value);
  }
}
